<div class="invite-dialog" role="dialog" aria-labelledby="invite-dialog-title">
  <!-- Header -->
  <div class="invite-dialog__header">
    <h2 id="invite-dialog-title" class="invite-dialog__title">
      {{ 'settings.users.invite.title' | translate }}
    </h2>
    <button type="button" class="invite-dialog__close" (click)="onCancel()" [attr.aria-label]="'common.close' | translate">&times;</button>
  </div>

  <!-- Body -->
  <div class="invite-dialog__body">
    <form [formGroup]="form">
      <!-- Email addresses pill input -->
      <zag-form-field
        [label]="'settings.users.invite.emails' | translate"
        [error]="getEmailError()"
        [hint]="'settings.users.invite.emailsHint' | translate"
        [required]="true"
        forId="invite-emails"
      >
        <zag-tags-input
          id="invite-emails"
          formControlName="emails"
          [placeholder]="'settings.users.invite.emailsPlaceholder' | translate"
          [validator]="isValidEmail"
        />
      </zag-form-field>

      <!-- Roles -->
      @if (availableRoles().length > 0) {
        <zag-form-field [label]="'settings.users.invite.roles' | translate">
          <div class="invite-dialog__roles">
            @for (role of availableRoles(); track role.id) {
              <zag-selection-row
                [label]="role.id"
                [description]="role.description ?? null"
                [checked]="selectedRoles().has(role.id)"
                (checkedChange)="onRoleToggle(role.id, $event)"
              />
            }
          </div>
        </zag-form-field>
      }

      <!-- Personal message -->
      <zag-form-field [label]="'settings.users.invite.message' | translate" forId="invite-message">
        <textarea
          id="invite-message"
          formControlName="message"
          class="invite-dialog__textarea"
          rows="3"
          [placeholder]="'settings.users.invite.messagePlaceholder' | translate"
        ></textarea>
      </zag-form-field>

      @if (submitError()) {
        <p class="invite-dialog__submit-error" role="alert">{{ submitError() | translate }}</p>
      }
    </form>
  </div>

  <!-- Footer -->
  <div class="invite-dialog__footer">
    <button type="button" zagButton="outlined" zagType="secondary" (click)="onCancel()">
      {{ 'settings.users.invite.cancel' | translate }}
    </button>
    <button type="button" zagButton [zagLoading]="isSubmitting()" [disabled]="!form.valid || isSubmitting()" (click)="onSubmit()">
      {{ 'settings.users.invite.send' | translate }}
    </button>
  </div>
</div>
